import logo from '../assets/logo.png';
import profile from '../assets/profile.png';
import javascript from '../assets/Javascript-logo.png';
import typescript from '../assets/Typescript-logo.png';
import python from '../assets/python-logo.png';
import ruby from '../assets/Ruby2.png';
import circle from '../assets/Cark.png';
import backend_dev from '../assets/backend_developer.png';
import frontend_dev from '../assets/frontend_developer.png';
import fullstack_dev from '../assets/fullstack_developer.png';
import mernstack_dev from '../assets/mernstack_developer.png';
import software_dev from '../assets/software_engineer.png';
import email from '../assets/email.png';
import phone from '../assets/phone.png';
import resume from '../assets/resume.pdf';

const images = {
  logo,
  profile,
  javascript,
  python,
  ruby,
  circle,
  backend_dev,
  frontend_dev,
  fullstack_dev,
  mernstack_dev,
  software_dev,
  email,
  phone,
  resume,
  typescript,
};

export { images }; // ✅ ONLY this
